import React, { useState, useContext } from "react";
import { FaGithub, FaLinkedin, FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Flags from "country-flag-icons/react/3x2";
import { LanguageContext } from "../languages/languageContext";

interface AsideProps {
  setLanguageId: React.Dispatch<React.SetStateAction<string>>;
}

const Aside: React.FC<AsideProps> = ({ setLanguageId }) => {
  const [showMenu, setShowMenu] = useState(false);
  const location = useLocation();
  const language = useContext(LanguageContext);

  return (
    <aside className="bg-black px-7 py-3 text-white md:fixed md:min-h-screen md:min-w-[320px]">
      <header className="pb-5">
        <Link to="/">
          <h2 className="font-['Lora'] text-3xl font-semibold">
            Ramon Rodrigues
          </h2>
        </Link>
        <a
          className="text-xl hover:underline"
          href="mailto:ramon@ramonrodrigues.dev"
        >
          ramon@ramonrodrigues.dev
        </a>

        <div className="flex gap-2 text-3xl">
          <a
            target="_blank"
            href="https://www.linkedin.com/in/rodrigues-ramon/"
          >
            <FaLinkedin />
          </a>
          <a target="_blank" href="https://github.com/ramonfrombr">
            <FaGithub />
          </a>
          <a
            target="_blank"
            href="https://www.youtube.com/channel/UCGP1Pi7EI6z3jOePL_peqOQ"
          >
            <FaYoutube />
          </a>
        </div>
      </header>

      <div className="mb-4 flex gap-1 p-[3px] [&>div]:rounded ">
        <div
          className={`flex cursor-pointer items-center p-1 ${
            language.id === "english" ? "bg-white" : "bg-transparent"
          }`}
          onClick={() => setLanguageId("english")}
          data-testid="english-language-button"
        >
          <Flags.US title="English" className="h-4" />
        </div>

        <div
          className={`flex cursor-pointer items-center p-1 ${
            language.id === "portuguese" ? "bg-white" : "bg-transparent"
          }`}
          onClick={() => setLanguageId("portuguese")}
          data-testid="portuguese-language-button"
        >
          <Flags.BR title="Portuguese" className="h-4" />
        </div>
      </div>

      <button
        onClick={() => setShowMenu((prev) => !prev)}
        className={`mb-3 rounded border border-white px-1 transition duration-150 hover:bg-white hover:text-slate-800 md:hidden ${
          showMenu && "bg-white text-slate-900"
        }`}
      >
        Menu
      </button>

      <div
        className={`overflow-hidden font-['Lora'] transition-all duration-500 ${
          showMenu ? "max-h-[500px] md:h-auto" : "max-h-0 md:max-h-[500px]"
        }`}
      >
        <ul className="border-t border-slate-700 pt-3 text-lg font-semibold [&_a:hover]:underline">
          <li>
            <Link onClick={() => setShowMenu(false)} to="/">
              <span
                className={`${
                  !location.pathname.includes("toolkit") &&
                  !location.pathname.includes("projects") &&
                  !location.pathname.includes("courses") &&
                  !location.pathname.includes("blog") &&
                  "underline"
                }`}
              >
                {language.aside.aboutme}
              </span>
            </Link>
          </li>

          <li
            className={`${
              location.pathname.includes("courses") && "underline"
            }`}
          >
            <Link onClick={() => setShowMenu(false)} to="/courses">
              {language.aside.courses}
            </Link>
          </li>
          <li
            className={`${
              location.pathname.includes("projects") && "underline"
            }`}
          >
            <Link onClick={() => setShowMenu(false)} to="/projects">
              {language.aside.projects}
            </Link>
          </li>
        </ul>
      </div>
    </aside>
  );
};

export default Aside;
